import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **Folder Documentation**

HawkClient allows you to create rich, well-structured documentation for your API folder using **Markdown**.  
This makes it easy to add descriptions, usage notes, and team communication directly alongside your requests.

The documentation is displayed within the folder view, making it accessible and visible to anyone exploring the API.

![Folder Documentation View](/docs/FolderDoc.png)

---

## **Editing Folder Documentation**

To modify the documentation, simply click on the **Edit Mode** button.  
This opens an inline editor where you can write or update content using Markdown syntax.

This feature is especially useful for collaborative teams, helping maintain clarity around the purpose, structure, and expected behavior of API folders.

![Edit Folder Documentation](/docs/FolderDocEdit.png)
`;

const FolderDocumentation = () => {
    return (
        <MarkDownRenderer
            title="Collection Documentation"
            markDownText={markdownContent}
        />
    );
};

export default FolderDocumentation;
